import React from 'react';
import ReactDOM from 'react-dom';

import App from './containers/index';

ReactDOM.render(
  <App />,
  document.getElementById('app'),
);
